import { FeatureTogglePort } from '../../../shared/ports'

export const USE_EVENT_TRACKING_FOR_CB_VIEW_KEY = 'EPR_TRACK_CB_VIEW_BY_EVENT'
export function useEventTrackingForCbView(
  featureToggleTestAdapter: FeatureTogglePort
): boolean {
  return featureToggleTestAdapter(USE_EVENT_TRACKING_FOR_CB_VIEW_KEY, false)
}
